import React from 'react';
import { HeartIcon } from 'src/features/white-labels/techcontemporary/app/components/welcome/heartIcon';
import { LocationIcon } from 'src/features/white-labels/techcontemporary/app/components/welcome/locationIcon';
import {
    StyledFlexBox,
    StyledTextWrapper,
    StyledTitleWrapper,
    StyledWelcomeContainer,
} from 'src/features/white-labels/techcontemporary/app/components/welcome/welcome.styles';
import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { Grid } from 'src/ui/common/atoms/grid';
import { Spacing } from 'src/ui/common/atoms/spacing';
import { Typography } from 'src/ui/common/atoms/typography';

export const Welcome = () => (
    <StyledWelcomeContainer>
        <Grid xs={1} sm={2} md={2} columnGap={40} columnGapLg={230}>
            <StyledTitleWrapper color="white" variant="title">
                Immerse yourself <br /> in a realm where pixels <br />
                come alive
            </StyledTitleWrapper>
            <StyledTextWrapper>
                <p>
                    <Typography color="gs50" size="sm">
                        Welcome to Tech Contemporary! This digital gallery is not just a space to appreciate art. It's a
                        platform where imagination meets technology, and creativity finds new avenues to flourish.
                    </Typography>
                </p>
                <p>
                    <Typography color="gs50" size="sm">
                        Join us on this exhilarating journey as we navigate the digital landscapes, bridging the gap
                        between traditional artistry and cutting-edge technology. Let us be your portal to a world where
                        physical art, digital art, and photo art meet, creating immersive and unforgettable experiences.
                    </Typography>
                </p>
                <Spacing padding="50px 0 0 0">
                    <StyledFlexBox flexDirectionMd="row" flexDirection="column" justifyContent="space-between">
                        <FlexBox gap="8" alignItems="center">
                            <LocationIcon />
                            <Typography variant="title" size="sm" color="gs50" uppercase>
                                Located in Copenhagen
                            </Typography>
                        </FlexBox>
                        <FlexBox gap="8" alignItems="center">
                            <HeartIcon />
                            <Typography variant="title" size="sm" color="gs50" uppercase>
                                Explorable around the world
                            </Typography>
                        </FlexBox>
                    </StyledFlexBox>
                </Spacing>
            </StyledTextWrapper>
        </Grid>
    </StyledWelcomeContainer>
);